import { Navigate, Route, Routes } from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import SendMoneyPage from "./pages/SendMoneyPage";
import RegisterRetailerPage from "./pages/RegisterRetailerPage";
import DashboardPage from "./pages/DashboardPage";
import HistoryPage from "./pages/HistoryPage";
import AddBankPage from "./pages/AddBankPage";
import BankChargesPage from "./pages/BankChargesPage";
import ApprovePaymentPage from "./pages/ApprovePaymentPage";
import SettingsPage from "./pages/SettingsPage";
import SmsSettingsPage from "./pages/SmsSettingsPage";
import OtpPage from "./pages/OtpPage";
import Layout from "./Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import AddBalancePage from "./pages/Addbalancepage";
import RetailersPage from "./pages/RetailersPage";
import RetailerTransactionLogPage from "./pages/RetailerTransactionLogPage";
import ViewProfilePage from "./pages/Viewprofilepage ";
import AdminBalanceLedger from "./pages/AdminBalanceLedger";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/otp" element={<OtpPage />} />
      <Route path="/forgotPassword/:token" element={<ForgotPasswordPage />} />
      <Route path="/forgatePassord/:token" element={<ForgotPasswordPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="send-money" element={<SendMoneyPage />} />
        <Route
          path="retailer-transactionlog"
          element={<RetailerTransactionLogPage />}
        />
        <Route
          path="/b2b/register-retailer"
          element={<RegisterRetailerPage />}
        />
        <Route path="history" element={<HistoryPage />} />
        <Route path="retailers" element={<RetailersPage />} />
        <Route
          path="/b2b/add-bank"
          element={
            <AdminRoute>
              <AddBankPage />
            </AdminRoute>
          }
        />
        <Route path="bank-charges" element={<BankChargesPage />} />
        <Route path="/b2b/approve-payment" element={<ApprovePaymentPage />} />
        <Route path="/b2b/settings" element={<SettingsPage />} />
        <Route path="/b2b/sms-settings" element={<AdminRoute><SmsSettingsPage /></AdminRoute>} />
        <Route path="view-profile" element={<ViewProfilePage />} />
        <Route path="/b2b/add-balance" element={<AddBalancePage />} />
        <Route path="/b2b/admin-balance-ledger" element={<AdminBalanceLedger />} />
      </Route>

      <Route path="*" element={<Navigate to="/" />} />
        
    </Routes>
  );
}

export default App;
